<template>
  <section>
   
    <el-form inline>
      <el-form-item label="库位编码">
        <el-input
          v-model="filters.keyword"
          placeholder="请输入库位编码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-select v-model="filters.enabled" multiple="">
          <el-option label="启用" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库名称">
        <el-select v-model="filters.wareid" multiple="" filterable>
          <el-option
            v-for="item in WareHousebase"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
     <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!-- 查询报表 -->
    
    <el-table-bar :fixed="true" :bottom="35">  
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        highlight-current-row
        v-loading="listLoading"
        @selection-change="selsChange"
         ref="multipleTable"
         @row-click="handleRowClick"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="locationCode" label="库位编码" sortable>
        </el-table-column>
        <el-table-column prop="warehouseCode" label="仓库编码" sortable>
        </el-table-column>
        <el-table-column prop="warehouseName" label="仓库名称" sortable>
        </el-table-column>
        <el-table-column prop="areaCode" label="库区编码" sortable>
        </el-table-column>
          <el-table-column prop="areaName" label="库区名称" sortable>
        </el-table-column>
        <el-table-column prop="status" label="是否启用" sortable>
          <template slot-scope="scope">{{
            scope.row.status ? "禁用" : "启用"
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="getbusinessLoglist(7, scope.row.warehouseLocationId)"
              type="text"
              size="small"
              >日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total" style="float:right;"
      >
      </el-pagination>
    </div>

    <!-- 新增模块 -->
    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="库位编码"
              prop="LocationCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.LocationCode"
                auto-complete="off"
                placeholder="请输入库位编码"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="库区名称"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-cascader
                placeholder="请选择库区名称"
                style="width: 100%"
                v-model="addForm.region"
                :options="options"
                filterable
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否启用"
              class="labelcall"
              label-width="120px"
              prop="Status"
            >
              <el-select v-model="addForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 修改模块 -->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editRuleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="库位编码"
              prop="LocationCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.LocationCode"
                auto-complete="off"
                placeholder="请输入库位编码"
                maxlength="50"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="库区名称"
              class="labelcall"
              label-width="120px"
            >
              <el-cascader
                style="width: 100%"
                placeholder="请选择库区名称"
                v-model="editForm.region"
                :options="editoptions"
                filterable
                :disabled="isVisible"
                :key="isResouceShow"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否启用"
              class="labelcall"
              label-width="120px"
              prop="Status"
            >
              <el-select v-model="editForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onEditSubmit" :loading="editLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 导入文件 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="导入文件"
      width="40%"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="text-align: center">
          <el-form-item>
            <el-button type="primary" @click="handleDownload"
              >下载导入模板</el-button
            >
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="text-align: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改日志 -->
    <el-dialog
      :visible.sync="logFormVisible"
      v-model="logFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-table
        :data="logtableData"
        height="500"
        border
        style="width: 100%"
        v-loading="loglistLoading"
      >
        <el-table-column prop="createBy" label="操作人" width="120" sortable>
        </el-table-column>
        <el-table-column prop="ip" label="操作人IP地址" width="140" sortable>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="操作时间"
          width="180"
          sortable
          :formatter="formatdatetime"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="操作内容"
         min-width="300"
          sortable
        >
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination
          @size-change="loghandleSizeChange"
          @current-change="loghandleCurrentChange"
          :current-page="logpage"
          :page-sizes="[10, 20, 50,100]"
          :page-size="logpageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="logtotal" style="float:right;"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </section>
</template>
<style>
</style>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
import {
  getWarehouseLocationbase,
  addWarehouseLocation,
  getWarehouseLocationList,
  editWarehouseLocation,
  editWarehouseLocationStatus,
  exportWarehouseLocation,
  importWarehouseLocation,
  getWarehouseLocationQueryById,
  downloadWarehouseLocation,
  getbusinessLog,
  getWarehousebase,
  downloadWarehouseLocationLabel,
} from "../../api/api";
import axios from "axios";
export default {
  components: { Toolbar },
  data() {
    return {
      isResouceShow: 0, // 绑定key值
      dialogVisible: false, //隐藏图片展示框
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      Importtext: "", //导入返回信息
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 50,
      tableData: [],
      options: [],
      filters: {
        keyword: "",
        enabled: "",
        wareid: "",
      },
      WareHousebase: [],

      buttonList: {},
      addFormVisible: false,
      addLoading: false,
      addForm: {
        LocationCode: "",
        region: [],
        Status: "1",
      },
      addFormRules: {
        LocationCode: [
          {
            required: true,

            message: "请输入库位编码",
            trigger: "blur",
          },
        ],

        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      editFormVisible: false,
      editLoading: false,
      editForm: {
        WarehouseLocationId: 0,
        LocationCode: "",
        region: [],
        Status: "1",
      },
      editFormRules: {
        AreaCode: [
          {
            required: true,
            message: "请输入库位编码",
            trigger: "blur",
          },
          
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      currentRow: null,
      sels: [],
      validation: true,
      importVisible: false,
      editoptions: [],
      isVisible: false,
      logFormVisible: false,
      logtableData: [],
      loglistLoading: false,
      logtotal: 0,
      logpage: 1,
      logpageSize: 50,
      logbusinessType: 0,
      logbusinessCode: 0,
      newfilters:{},
    };
  },
  methods: {
    //加载权限按钮
   callFunction(item) {
      if (item.name === "查询") {
         this.page=1;
         this.newfilters =JSON.parse(JSON.stringify(this.filters)) ;
          this.getReportlist.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //弹出导入文件框
    importExport() {
      this.Importtext = "";
      this.importVisible = true;
    },
    //弹出新增框
    onSubmitadd() {
      this.addFormVisible = true;
      this.addLoading = false;
    },
    //弹出修改框
    onSubmitedit() {
      let row = {};
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length === 1) {
        row = this.sels[0];
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      this.editLoading = false;

      if (!row || row.warehouseId == 0) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editoptions = [];

      console.log(this.editoptions);

      let pata = {
        id: row.warehouseLocationId,
      };
      ++this.isResouceShow;
      getWarehouseLocationQueryById(pata).then((res) => {
        if (res.data.success) {
          let editdata = res.data.response;
          this.editoptions = editdata.listtree;
          this.editForm.WarehouseLocationId = editdata.warehouseLocationId;
          this.editForm.LocationCode = editdata.locationCode;
          this.editForm.Status = editdata.status + "";
          this.editForm.region = [];
          this.editForm.region.push(editdata.warehouseId + ""),
            this.editForm.region.push(editdata.warehouseAreaId + ""),
            console.log(this.editForm);
          this.editFormVisible = true;
          this.isVisible = editdata.isVisible;
          this.editFormVisible = true;
        } else {
          this.$message({
            message:res.data.msg,
            type: "error",
          });
        }
      });
    },

    //隐藏新增修改框
    onSubmicancel() {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.importVisible = false;
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },
    //获取每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getReportlist();
    },
    //获取页码
    handleCurrentChange(val) {
      this.page = val;
      this.getReportlist();
    },
    //多选
    selsChange(sels) {
      this.sels = sels;
      console.log(sels, 1111);
    },
    //新增
    onAddSubmit() {
      let _this = this;
      let para = Object.assign({}, this.addForm);
      console.log(para);

      if (para.region.length == 0) {
        this.$message({
          message: "请选择库区",
          type: "error",
        });
        return;
      }
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            console.log(para);
            this.addLoading = true;
            para.WarehouseId = para.region[0];
            para.WarehouseAreaId = para.region[1];
            addWarehouseLocation(para).then((res) => {
              this.addLoading = false;
              console.log(res);
              if (res.data.success) {
                this.addFormVisible = false;
                this.$refs["addRuleForm"].resetFields();
                this.getReportlist();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }).catch((err)=>{
            console.log(err);
          });
        }
      });
    },
    //修改
    onEditSubmit() {
      let _this = this;
      let para = Object.assign({}, this.editForm);
      if (para.region.length == 0) {
        this.$message({
          message: "您的仓库权限已被修改，请重新登录",
          type: "error",
        });
        return;
      }
      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            var user = JSON.parse(window.localStorage.user);
            if (!user && user.id == 0) {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            this.editLoading = true;
            para.WarehouseId = para.region[0];
            para.WarehouseAreaId = para.region[1];
            console.log(para, user);
            editWarehouseLocation(para).then((res) => {
              console.log(res);
              this.editLoading = false;
              if (res.data.success) {
                this.editFormVisible = false;
                this.$refs["editRuleForm"].resetFields();
                this.getReportlist();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }).catch((err)=>{
            console.log(err);
          });
        }
      });
    },

    //查询
    getReportlist(item) {
      
      let pata = {
        page: this.page,
        pageSize: this.pageSize,
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
      };
      this.listLoading = true;
      getWarehouseLocationList(pata).then((res) => {
        console.log(res);
        this.tableData = res.data.response.pageData;
        this.total = res.data.response.total;
        this.listLoading = false;
      });
    },
    //导出
    handleExport() {
      let row = this.sels;
      let warelist = "";
      row.forEach((item) => {
        warelist += item.warehouseLocationId + ",";
      });
      let pata = {
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
        warehouseareaid: warelist.slice(0, warelist.length - 1),
      };
       const loading = this.$loading({
          lock: true,
          text: '导出中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
      exportWarehouseLocation(pata);
      loading.close();
    },
    //点击启用按钮
    handleEnable() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error",
        });

        return;
      }

      if (row.length == 1) {
        if (row[0].status == 0) {
          this.validation = false;
          this.$message({
            message: "当前数据为启用状态，无需启用！",
            type: "error",
          });
          return;
        }
      }

      row.forEach((item) => {
        if (item.status == 0) {
          this.validation = false;
          this.$message({
            message: "请选择禁用的数据启用！",
            type: "error",
          });
          return false;
        }
      });

      let para = Object.assign([], row);

      console.log(para);
      if (this.validation) {
        this.$confirm("确认启用吗?", "提示", {}).then(() => {
          for (let i = 0; i < para.length; i++) {
            para[i].Status = 0;
          }
          editWarehouseLocationStatus(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getReportlist();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }).catch((err)=>{
            console.log(err);
          });
      }
    },
    //点击禁用按钮
    handleStop() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择启用的数据禁用！",
          type: "error",
        });

        return false;
      }
      if (row.length == 1) {
        if (row[0].status == 1) {
          this.validation = false;
          this.$message({
            message: "当前数据为禁用状态，无需禁用！！",
            type: "error",
          });
          return;
        }
      }
      row.forEach((item) => {
        if (item.status == 1) {
          this.validation = false;
          this.$message({
            message: "请选择启用的数据禁用！",
            type: "error",
          });
          return false;
        }
      });
      if (this.validation) {
        let para = Object.assign([], row);
        this.$confirm("确认禁用吗?", "提示", {}).then(() => {
          for (let i = 0; i < para.length; i++) {
            para[i].Status = 1;
          }
          editWarehouseLocationStatus(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getReportlist();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }).catch((err)=>{
            console.log(err);
          });
      }
    },

    //加载基础资料
    getBasicdatalist() {
      getWarehouseLocationbase("").then((res) => {
        console.log(res);
        this.options = res.data.response.listtree;
      });
      // getWarehousebase("").then((res) => {
      //   console.log(res);
      //   this.WareHousebase = res.data.response.wareHouse;
      // });
      let user = JSON.parse(window.localStorage.user);
      this.WareHousebase = user.warehouseList;
    },

    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }

      return extension || extension2;
    },
    //上传文件
    UploadExcel(param) {
      console.log(param, "文件");
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      var _this = this;
      axios({
        url: importWarehouseLocation,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            console.log("导入成功");
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getReportlist();
          } else {
            // this.$message({
            //   message: res.data.msg,
            //   type: "error",
            // });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },
    //下载模板
    handleDownload() {
      let url = downloadWarehouseLocation;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    //下载库位标签
    downloadPallet() {
      let row = this.sels;
      let warelist = "";
      row.forEach((item) => {
        warelist += item.warehouseLocationId + ",";
      });
      let pata = {
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        wareid: this.newfilters.wareid.toString(),
        warehouseareaid: warelist.slice(0, warelist.length - 1),
      };
       const loading = this.$loading({
          lock: true,
          text: '下载中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });

      downloadWarehouseLocationLabel(pata).then((res) => {
        loading.close();
        if (res.data.success) {
           window.open(res.data.response, '_blank')
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    //获取每页条数
    loghandleSizeChange(val) {
      this.logpageSize = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //获取页码
    loghandleCurrentChange(val) {
      this.logpage = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //查询
    getbusinessLoglist(businessType, businessCode) {
      this.logbusinessType = businessType;
      this.businessCode = businessCode;
      this.logFormVisible = true;
      let pata = {
        businessType: this.logbusinessType,
        businessCode: this.businessCode,
        page: this.logpage,
        pageSize: this.logpageSize,
      };
      this.loglistLoading = true;
      getbusinessLog(pata).then((res) => {
        console.log(res);
        this.logtableData = res.data.response.pageData;
        this.logtotal = res.data.response.total;
        this.loglistLoading = false;
      });
    },
    formatdatetime: function (row) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.createTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
  },
  mounted() {
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    // console.log(111);
    this.getBasicdatalist();
   
  },
  watch: {
    options: {
      handler(v1, v2) {
        ++this.isResouceShow;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>